import api from '@/api';
import * as dateutil from '@/util/date-helper.ts';

export default {

    getCalendarResource(item: any) {
        return api.post<any>({
            url: '/api/calendar/CalendarResource/get?funcName=getCalendarResource',
            data: {
				ID: item.ID,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TC_RESOURCE_TYPE: item.USE_TC_RESOURCE_TYPE || false,

            }
        }).then((res) => {
           return res;
        });
    },

    getAllCalendarResource() {
        return api.post<Array<any>>({
            url: '/api/calendar/CalendarResource/all?funcName=getAllCalendarResource',
        }).then((res) => {
            return res.map((data) => {
                let result = {
                    ...data,
                };
                return result;
            });
        });
    },

    getFindCalendarResource(item: any) {
        return api.post<Array<any>>({
            url: '/api/calendar/CalendarResource/find?funcName=getFindCalendarResource',
            data: {
				ID: item.ID || null,
				DisplayName: item.DisplayName || null,
				Type: item.Type || null,
				IsDeleted: item.IsDeleted || null,
				Param1: item.Param1 || null,
				Param2: item.Param2 || null,
				Param3: item.Param3 || null,
				Param4: item.Param4 || null,
				Param5: item.Param5 || null,
				Param6: item.Param6 || null,
				Param7: item.Param7 || null,
				Param8: item.Param8 || null,
				Param9: item.Param9 || null,
				Param10: item.Param10 || null,
				EumPageNumber: item.EumPageNumber || null,
				EumRowsPerPage: item.EumRowsPerPage || null,
				EumSearchCategory: item.EumSearchCategory || null,
				EumSearchKey: item.EumSearchKey || null,
				EumNoCondition: item.EumNoCondition || null,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TC_RESOURCE_TYPE: item.USE_TC_RESOURCE_TYPE || false,

            }
        }).then((res) => {
            return res.map((data) => {
                let result = {
                    ...data,
                };
                return result;
            });
        });
    },

    createCalendarResource(item: any) {
        return api.post<any>({
            url: '/api/calendar/CalendarResource/create?funcName=createCalendarResource',
            data: {
				DisplayName: item.DisplayName,
				Type: item.Type,
				IsDeleted: item.IsDeleted,
				Param1: item.Param1,
				Param2: item.Param2,
				Param3: item.Param3,
				Param4: item.Param4,
				Param5: item.Param5,
				Param6: item.Param6,
				Param7: item.Param7,
				Param8: item.Param8,
				Param9: item.Param9,
				Param10: item.Param10,
				CreatedId: item.CreatedId,
				UpdatedId: item.UpdatedId,
				CreatedDate: item.CreatedDate,
				UpdatedDate: item.UpdatedDate,
				CalendarEventList: item.CalendarEventList || [],
				ResourceType: item.ResourceType,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TC_RESOURCE_TYPE: item.USE_TC_RESOURCE_TYPE || false,

            }
        });
    },

    updateCalendarResource(item: any) {
        return api.post<any>({
            url: '/api/calendar/CalendarResource/update?funcName=updateCalendarResource',
            data: {
				ID: item.ID,
				DisplayName: item.DisplayName,
				Type: item.Type,
				IsDeleted: item.IsDeleted,
				Param1: item.Param1,
				Param2: item.Param2,
				Param3: item.Param3,
				Param4: item.Param4,
				Param5: item.Param5,
				Param6: item.Param6,
				Param7: item.Param7,
				Param8: item.Param8,
				Param9: item.Param9,
				Param10: item.Param10,
				CreatedId: item.CreatedId,
				UpdatedId: item.UpdatedId,
				CreatedDate: item.CreatedDate,
				UpdatedDate: item.UpdatedDate,
				CalendarEventList: item.CalendarEventList || [],
				ResourceType: item.ResourceType,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TC_RESOURCE_TYPE: item.USE_TC_RESOURCE_TYPE || false,

            }
        });
    },

    deleteCalendarResource(item: any) {
        return api.post<any>({
            url: '/api/calendar/CalendarResource/delete?funcName=deleteCalendarResource',
            data: {
				ID: item.ID,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TC_RESOURCE_TYPE: item.USE_TC_RESOURCE_TYPE || false,

            }
        });
    },
}
